import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'


@Component({
  selector: 'app-list-view-modal',
  templateUrl: './list-view-modal.component.html',
  styleUrls: ['./list-view-modal.component.css']
})
export class ListViewModalComponent {
  @Input() headerText: string

}
